import React, { useState } from 'react'
import Swal from 'sweetalert2';
import "../../../styles/contacto/contacto.css"
import Logo from "../../Reutilizables/Logo"
import Menu from "../../Reutilizables/Menu"
import MenuInicioSuscrito from '../inicioSuscrito/MenuInicioSuscrito';
import FAQ from '../FAQ';
import Footer from '../../Reutilizables/Footer';
import Redes from "../../Reutilizables/Redes"

function Contacto({ user }) {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch('https://formspree.io/f/xgejravn', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        // Manejar éxito aquí
        Swal.fire({
          icon: 'success',
          title: 'Mensaje enviado exitosamente',
          text: '¡Nos comunicaremos contigo lo mas pronto posible!',
        });
        // Puedes reiniciar el estado del formulario si lo deseas
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      } else {
        // Manejar errores aquí
        console.error('Hubo un problema al enviar el mensaje');
      }
    } catch (error) {
      console.error('Hubo un error en la solicitud:', error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  return (
    <>
      <div className='container-logo-menu-contacto'> 
    	  <Logo />
        {
          user ? <MenuInicioSuscrito /> : <Menu />
        }

      </div>
      <Redes />
      <div className='container-contact-FAQ'>

        <form className="formu" onSubmit={handleSubmit}>
          <h2 className="title-contact">Contactanos</h2>

          <label className="p-info">
            Nombre
            <input
              className="inputs-info"
              type="text"
              name="name"
              value={formData.name}
              placeholder="Escribe tu nombre aquí..."
              onChange={handleInputChange}
              required
            />
          </label>

          <label className="p-info">
            Correo
            <input
              className="inputs-info"
              type="email"
              name="email"
              value={formData.email}
              placeholder="Digita tu correo y te contactamos..."
              onChange={handleInputChange}
              required
            />
          </label>

          <label className="p-info">
            Mensaje
            <textarea
              className="inputs-info"
              name="message"
              value={formData.message}
              placeholder="Que te gustaria decirnos..."
              onChange={handleInputChange}
              required
            />
          </label>

          <button type="submit" className="button-send">
            Enviar mensaje
          </button>

          <div className='info-extra'>
            <div>
              <span className="span-info fa fa-phone"></span>
              318 821 7116
            </div>
            <div>
              <span className="span-info fa fa-envelope"></span>
              Impuestosmunicipales23@gmail.com
            </div>
          </div>
        </form>
          
        <div className='FAQ'>
          <FAQ />
        </div>

      </div>
      <div className='foooter-contacto'>
        <Footer />
      </div>
    </>
  )
}



export default Contacto